import React, { Fragment } from "react";
import * as styles from "./ForklyWidget.module.css";
import ForklyIcon from "../../assets/forkly_icon.svg";

const renderLine = (text) =>
  text.split(/(\*\*[^*]+\*\*)/).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i}>{part.slice(2, -2)}</strong>
    ) : (
      part
    ),
  );

const BotAvatar = () => (
  <img src={ForklyIcon} alt="" className={styles.mini} />
);

const SummaryCard = ({ title, rows }) => (
  <div className={styles.summaryCard}>
    {title && <h4 className={styles.summaryTitle}>{title}</h4>}
    {rows.map(([k, v], ri) => (
      <div className={styles.summaryLi} key={ri}>
        <span className={styles.summaryK}>{k}</span>
        <span className={styles.summaryV}>{v}</span>
      </div>
    ))}
  </div>
);

const TextBubble = ({ msg }) => (
  <div
    className={`${styles.bubble} ${
      msg.from === "user" ? styles.bubbleUser : styles.bubbleFork
    } ${msg.highlight ? styles.bubbleHighlight : ""}`}
  >
    {msg.text.split("\n").map((lineText, li) => (
      <Fragment key={li}>
        {li > 0 && <br />}
        {renderLine(lineText)}
      </Fragment>
    ))}
  </div>
);

const ForklyMessages = ({ messages, busy, endRef }) => (
  <div className={styles.chat}>
    {messages.map((msg) => (
      <div
        key={msg.id}
        className={`${styles.row} ${
          msg.from === "user" ? styles.rowUser : styles.rowFork
        }`}
      >
        {msg.from === "bot" && <BotAvatar />}
        {msg.card && Array.isArray(msg.rows) ? (
          <SummaryCard title={msg.title} rows={msg.rows} />
        ) : (
          <TextBubble msg={msg} />
        )}
      </div>
    ))}

    {busy && (
      <div className={`${styles.row} ${styles.rowFork}`}>
        <BotAvatar />
        <div className={`${styles.bubble} ${styles.bubbleFork} ${styles.typing}`}>
          <span className={styles.dots}>
            <span />
            <span />
            <span />
          </span>
        </div>
      </div>
    )}

    <div ref={endRef} />
  </div>
);

export default ForklyMessages;
